import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker'; // 📘reactdatepicker.com
import { InputGroup } from 'react-bootstrap';
import { IconButton } from '@sumologic/yama-ds-components';

import {
    toUTCDate,
    removeGmtOffset,
    shiftDateByHourOffset,
    formatTimeAsUserSettings
} from '~/modules/helpers/date';

import Icon from '~/components/Icon/Icon';

// prettier-ignore
const PortalDatePicker = ({
    type, // 𝘤𝘶𝘴𝘵𝘰𝘮𝘧𝘪𝘦𝘭𝘥
    value, // 𝘶𝘯𝘪𝘹 𝘵𝘪𝘮𝘦𝘴𝘵𝘢𝘮𝘱
    selected,
    disabled,
    isInvalid,
    isRequired,
    editInline,
    className,
    onChange,
    ...rest
}) => {
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [picked, setPicked] = useState(null);

    const ref = useRef({
        userHourOffset: CURRENT_USER.offset2num / 3600,
        portalStyle: {
            position: 'absolute',
            top: 'auto',
            right: 'auto',
            bottom: 'auto',
            left: 'auto'
        }
    }).current;

    const [
        formattedInputValue,
        valueAsDate
    ] =
        value
            ? [
                formatTimeAsUserSettings(value, type),
                new Date(value * 1e3)
              ]
            : [
                '', // 𝘦𝘮𝘵𝘱𝘺 𝘧𝘪𝘦𝘭𝘥
                toUTCDate(new Date())
              ];

    let pickerValue = picked;
    if (!pickerValue) {
        const valueAsDateShiftedByUserHourOffset = shiftDateByHourOffset(valueAsDate, ref.userHourOffset);
        pickerValue = removeGmtOffset(valueAsDateShiftedByUserHourOffset);
        // console.log({ valueAsDate, valueAsDateShiftedByUserHourOffset, pickerValue });
    }

    useEffect(() => {
        const handleMousedown = event => {
            const portalEl = ref.portalEl;
            if (portalEl) {
                const el = event.target;
                if (
                    el !== ref.iconEl &&
                    el !== ref.inputEl &&
                    !portalEl.contains(el)
                ) {
                    // 𝘤𝘭𝘪𝘤𝘬𝘦𝘥 𝘰𝘶𝘵𝘴𝘪𝘥𝘦 𝘱𝘪𝘤𝘬𝘦𝘳
                    setShowDatePicker(false);
                }
            }
        };
        document.addEventListener('mousedown', handleMousedown);
        return () => {
            document.removeEventListener('mousedown', handleMousedown);
        };
    }, [ref.portalEl]);

    const inputGroupClasses =
        className?.length
            ? (className.map // 𝘢𝘴𝘴𝘶𝘮𝘦 𝘪𝘵 𝘪𝘴 𝘢𝘯 𝘢𝘳𝘳𝘢𝘺
                ? className
                : className.split(' ')).filter(e => 'form-control' !== e)
            : [];

    inputGroupClasses.push(
        'portal-datepicker',
        showDatePicker
            ? 'open'
            : 'closed'
    );

    return (
        <>
            {showDatePicker &&
                ReactDOM.createPortal(
                    <div
                        ref={el => {
                            ref.portalEl = el;
                        }}
                        style={
                            ref.portalStyle
                        }
                        className={
                            `portal datepicker ${
                                picked ? 'has' : 'no'
                            }-date-picked`
                        }
                    >
                        <DatePicker
                            inline
                            selected={pickerValue}
                            onChange={pickedDate => {
                                setPicked(pickedDate);
                                onChange(pickedDate);
                            }}
                            {...rest}
                        />
                    </div>,
                    document.body
                )}
            <InputGroup className={inputGroupClasses.join('\u0020')}>
                <input
                    readOnly
                    type="text"
                    value={formattedInputValue}
                    disabled={disabled}
                    className={isInvalid ? 'is-invalid' : null}
                    ref={el => {
                        ref.inputEl = el;
                    }}
                    onClick={event => {
                        // 𝘛𝘰𝘨𝘨𝘭𝘦 𝘵𝘩𝘦 𝘷𝘪𝘴𝘪𝘣𝘪𝘭𝘪𝘵𝘺 𝘰𝘧 𝘵𝘩𝘦 𝘥𝘢𝘵𝘦 𝘱𝘪𝘤𝘬𝘦𝘳
                        const toggle = !showDatePicker;
                        if (toggle) {
                            // 𝘜𝘱𝘥𝘢𝘵𝘦 𝘵𝘩𝘦 𝘱𝘰𝘳𝘵𝘢𝘭 𝘴𝘵𝘺𝘭𝘦 𝘸𝘪𝘵𝘩 𝘯𝘦𝘸 𝘱𝘰𝘴𝘪𝘵𝘪𝘰𝘯
                            const newPortalStyle = {
                                position: 'absolute',
                                top: 'auto',
                                right: 'auto',
                                bottom: 'auto',
                                left: 'auto'
                            };
                            const rect = event.target.getBoundingClientRect();
                            const { innerHeight, innerWidth } = event.view;
                            const x = rect.x; // 𝘪𝘯𝘱𝘶𝘵𝘌𝘭 𝘣𝘰𝘶𝘯𝘥𝘪𝘯𝘨𝘊𝘭𝘪𝘦𝘯𝘵𝘙𝘦𝘤𝘵.𝘅
                            if (x > innerWidth / 2) {
                                newPortalStyle.right = innerWidth - x - rect.width;
                            } else {
                                newPortalStyle.left = rect.left;
                            }
                            const y = rect.y; // 𝘪𝘯𝘱𝘶𝘵𝘌𝘭 𝘣𝘰𝘶𝘯𝘥𝘪𝘯𝘨𝘊𝘭𝘪𝘦𝘯𝘵𝘙𝘦𝘤𝘵.𝘆
                            if (y > innerHeight / 2) {
                                newPortalStyle.bottom = innerHeight - y;
                            } else {
                                newPortalStyle.top = rect.top + rect.height;
                            }
                            ref.portalStyle = newPortalStyle;
                        }
                        setShowDatePicker(toggle);
                    }}
                />
                {value &&
                    !disabled &&
                    (showDatePicker || (!isRequired && !editInline)) && (
                        <div className="input-group-append d-flex">
                            <IconButton
                                onClick={() => {
                                    setShowDatePicker(false);
                                    setPicked(null);
                                    onChange?.(null);
                                }}
                                size="small"
                            >
                                <Icon
                                    type="cross"
                                    size="sm"
                                    ref={el => {
                                        ref.iconEl = el;
                                    }}
                                />
                            </IconButton>
                        </div>
                    )}
            </InputGroup>
        </>
    );
};

PortalDatePicker.propTypes = {
    type: PropTypes.number,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date)
    ]),
    selected: PropTypes.instanceOf(Date), // react-datepicker
    disabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    isRequired: PropTypes.bool,
    editInline: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    onChange: PropTypes.func
};

// PortalDatePicker.defaultProps = {};

export default PortalDatePicker;
